import type { PeriodSpec } from '@contracts';

const ymd = (d: Date): string => {
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
};

/** Resuelve un PeriodSpec (preset o rango) a `{from, to}` en fechas locales YYYY-MM-DD. */
export function resolvePeriod(spec: PeriodSpec): { from: string; to: string } {
  if (typeof spec !== 'string') return { from: spec.from, to: spec.to };

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const d = new Date(today);

  switch (spec) {
    case 'today':
      return { from: ymd(today), to: ymd(today) };
    case 'yesterday':
      d.setDate(d.getDate() - 1);
      return { from: ymd(d), to: ymd(d) };
    case 'this_week': {
      const dow = (today.getDay() + 6) % 7; // lunes = 0
      d.setDate(d.getDate() - dow);
      return { from: ymd(d), to: ymd(today) };
    }
    case 'last_week': {
      const dow = (today.getDay() + 6) % 7;
      const end = new Date(today);
      end.setDate(end.getDate() - dow - 1);
      const start = new Date(end);
      start.setDate(start.getDate() - 6);
      return { from: ymd(start), to: ymd(end) };
    }
    case 'this_month':
      return { from: ymd(new Date(today.getFullYear(), today.getMonth(), 1)), to: ymd(today) };
    case 'last_month': {
      const first = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const last = new Date(today.getFullYear(), today.getMonth(), 0);
      return { from: ymd(first), to: ymd(last) };
    }
    case 'last_7d':
      d.setDate(d.getDate() - 6);
      return { from: ymd(d), to: ymd(today) };
    case 'last_30d':
      d.setDate(d.getDate() - 29);
      return { from: ymd(d), to: ymd(today) };
    case 'quarter': {
      const q = Math.floor(today.getMonth() / 3);
      return { from: ymd(new Date(today.getFullYear(), q * 3, 1)), to: ymd(today) };
    }
    case 'ytd':
      return { from: ymd(new Date(today.getFullYear(), 0, 1)), to: ymd(today) };
    default:
      return { from: ymd(new Date(today.getFullYear(), today.getMonth(), 1)), to: ymd(today) };
  }
}
